import React, { useState, useEffect } from "react";
import Senior1 from "../assets/Senior1.jpg";
import Senior2 from "../assets/Senior2.jpg";
import Senior3 from "../assets/Senior3.jpg";
import Senior4 from "../assets/Senior4.jpg";

const slides = [
  {
    image: Senior4,
    title: "Companionship",
    description:
      "Companion care is primarily emotional support and socialization, offering non-medical service to older adults or people with disabilities.",
  },
  {
    image: Senior2,
    title: "Personal Care",
    description:
      "Helping with daily activities like bathing, grooming, and dressing for seniors to live comfortably.",
  },
  {
    image: Senior3,
    title: "Respite Care",
    description:
      "Providing relief to family caregivers by offering short-term assistance for their loved ones.",
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  // ✅ Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full mt-6 h-[320px] sm:h-[420px] md:h-[520px] lg:h-[650px] overflow-hidden">
      
      {/* ✅ Blurred Background for a smooth full look */}
      <div className="absolute inset-0">
        <img
          src={slides[current].image}
          alt=""
          className="w-full h-full object-cover blur-2xl scale-110 transition-all duration-700 ease-in-out"
        />
        <div className="absolute inset-0 bg-black bg-opacity-25"></div>
      </div>

      {/* ✅ Main Image — heads fully visible now */}
      <img
        src={slides[current].image}
        alt={slides[current].title}
        className="relative w-full h-full object-contain z-10 transition-opacity duration-700 ease-in-out"
      />

      {/* ✅ Text Overlay */}
      <div className="absolute bottom-8 left-4 sm:left-12 max-w-md sm:max-w-lg text-left z-20 px-4 sm:px-0">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white drop-shadow-lg">
          {slides[current].title}
        </h2>
        <p className="text-sm sm:text-base md:text-lg text-white drop-shadow-md mt-2">
          {slides[current].description}
        </p>
        <button className="mt-4 bg-blue-600 px-4 py-2 sm:px-6 sm:py-3 rounded-lg text-white font-semibold hover:bg-blue-700 transition">
          View More
        </button>
      </div>

      {/* ✅ Left Arrow — perfectly centered */}
      <button
        className="absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 
                   bg-[#2C597D] text-white w-8 h-8 sm:w-10 sm:h-10 flex items-center 
                   justify-center rounded-full shadow-lg hover:bg-[#1E4361] transition z-30"
        onClick={() =>
          setCurrent(current === 0 ? slides.length - 1 : current - 1)
        }
      >
        ‹
      </button>

      {/* ✅ Right Arrow — perfectly centered */}
      <button
        className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 
                   bg-[#2C597D] text-white w-8 h-8 sm:w-10 sm:h-10 flex items-center 
                   justify-center rounded-full shadow-lg hover:bg-[#1E4361] transition z-30"
        onClick={() =>
          setCurrent(current === slides.length - 1 ? 0 : current + 1)
        }
      >
        ›
      </button>

      {/* ✅ Slide Indicator Dots */}
      <div className="absolute bottom-3 sm:bottom-4 w-full flex justify-center z-30">
        {slides.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 sm:w-3 sm:h-3 mx-1 rounded-full cursor-pointer transition-all ${
              current === index ? "bg-white scale-125" : "bg-gray-400 opacity-70"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
